import { render, staticRenderFns } from "./OverallTotalpolicies.vue?vue&type=template&id=6837279c&"
import script from "./OverallTotalpolicies.vue?vue&type=script&lang=js&"
export * from "./OverallTotalpolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports